import React, { useEffect } from 'react';
import { Route, Routes, useLocation, useParams } from 'react-router';
import { getConfig } from '@edx/frontend-platform';
import { FormattedMessage } from '@edx/frontend-platform/i18n';

import PageLoading from '../generic/PageLoading';

const CoursewareRedirect = () => {
  const { courseId, unitId } = useParams();
  useEffect(() => {
    window.location.assign(
      `${getConfig().LMS_BASE_URL}/courses/${courseId}/jump_to/${unitId}?experience=legacy`
    );
  }, [courseId, unitId]);
  return null;
};

const CourseHomeRedirect = () => {
  const { courseId } = useParams();
  useEffect(() => {
    window.location.assign(`${getConfig().LMS_BASE_URL}/courses/${courseId}/`);
  }, [courseId]);
  return null;
};

const SurveyRedirect = () => {
  const { courseId } = useParams();
  useEffect(() => {
    window.location.assign(`${getConfig().LMS_BASE_URL}/courses/${courseId}/survey`);
  }, [courseId]);
  return null;
}

const DashboardRedirect = () => {
  const location = useLocation();
  useEffect(() => {
    window.location.assign(`${getConfig().LMS_BASE_URL}/dashboard${location.search}`);
  }, [location.search]);
  return null;
}

export default () => {
  return (
    <div className="flex-grow-1">
      <PageLoading srMessage={(
        <FormattedMessage
          id="learn.redirect.interstitial.message"
          description="The screen-reader message when a page is about to redirect"
          defaultMessage="Redirecting..."
        />
      )}
      />
      <Routes>
        <Route
          path={`/courseware/:courseId/unit/:unitId`}
          element={<CoursewareRedirect />}
        />
        <Route
          path={`/course-home/:courseId`}
          element={<CourseHomeRedirect />}
        />
        <Route
          path={`/survey/:courseId`}
          element={<SurveyRedirect />}
        />
        <Route
          path={`/dashboard`}
          element={<DashboardRedirect />}
        />
      </Routes>
    </div>
  );
};
